import { useEffect } from 'react';
import Bitbucket from 'logos/Bitbucket';
import QodoAnteater from 'logos/QodoAnteater';
import { ArrowLeftRight } from 'lucide-react';
import { spawn } from 'utils/translations';
import { Loader } from '../../Loader/Loader';
import { API_BASE_URL_KEY, OPENER_ORIGIN_KEY } from './OAuthCallbackReceiver';

const spawnRedirect = spawn('dialogs.bitbucket-installation.oauth-redirect');

const BITBUCKET_AUTHORIZE_URL = 'https://bitbucket.org/site/oauth2/authorize';

/**
 * Lightweight popup page that redirects to Bitbucket OAuth.
 * Expects query params: origin, client_id, scope, callback_url, api_base_url.
 * Stores opener origin and API base URL in sessionStorage for OAuthCallbackReceiver.
 */
export const OAuthRedirectPage = () => {
  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const openerOrigin = searchParams.get('origin');
    const clientId = searchParams.get('client_id');
    const scope = searchParams.get('scope');
    const callbackUrl = searchParams.get('callback_url');
    const apiBaseUrl = searchParams.get('api_base_url');

    if (!openerOrigin || !clientId) return;

    sessionStorage.setItem(OPENER_ORIGIN_KEY, openerOrigin);

    if (apiBaseUrl) {
      sessionStorage.setItem(API_BASE_URL_KEY, apiBaseUrl);
    }

    const params = new URLSearchParams({
      client_id: clientId,
      response_type: 'code',
      ...(scope && { scope }),
      ...(callbackUrl && { redirect_uri: callbackUrl }),
    });

    window.location.href = `${BITBUCKET_AUTHORIZE_URL}?${params.toString()}`;
  }, []);

  return (
    <div className="flex h-screen flex-col items-center justify-center gap-6">
      <div className="flex items-center gap-4">
        <QodoAnteater size={48} />
        <ArrowLeftRight className="text-text-bg-neutral-mid" size={20} />
        <Bitbucket size={48} />
      </div>

      <div className="flex flex-col items-center gap-3">
        <Loader />
        <p className="text-sm text-text-bg-neutral-mid">
          {spawnRedirect('loading')}
        </p>
      </div>
    </div>
  );
};
